/**
 *
 * Common mobile utils for roles
 *
 */

export const getRowHeight = () => 80;
